import { defineComponent, openBlock, createBlock, unref, withCtx, createVNode, createElementVNode } from "vue";
import { CdrBanner, IconWarningFill } from "@rei/cedar";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductReviewsWarningStateBanner",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(CdrBanner), {
        class: "warning-message",
        type: "warning",
        role: "alert"
      }, {
        "icon-left": withCtx(() => [createVNode(unref(IconWarningFill))]),
        default: withCtx(() => [_cache[0] || (_cache[0] = createElementVNode("span", null, [createElementVNode("span", {
          class: "warning-message--bold"
        }, " No reviews match selected filters ")], -1))]),
        _: 1,
        __: [0]
      });
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductReviewsWarningStateBanner2.mjs.map
